import { render } from "./StockTablePanel.vue?vue&type=template&id=4b622c14&scoped=true"
import script from "./StockTablePanel.vue?vue&type=script&lang=js"
export * from "./StockTablePanel.vue?vue&type=script&lang=js"

import "./StockTablePanel.vue?vue&type=style&index=0&id=4b622c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b622c14"]])

export default __exports__